import { useEffect } from 'react';

const CodeProtection = () => {
  useEffect(() => {
    // Disable right-click
    const handleContextMenu = (e) => {
      e.preventDefault();
      return false;
    };

    // Disable text selection
    const handleSelectStart = (e) => {
      e.preventDefault();
      return false;
    };

    // Disable copy/cut
    const handleCopy = (e) => {
      e.preventDefault();
      return false;
    };

    // Disable keyboard shortcuts for dev tools and copying
    const handleKeyDown = (e) => {
      // F12, Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+U, Ctrl+S, Ctrl+C, Ctrl+X
      if (
        e.keyCode === 123 || // F12
        (e.ctrlKey && e.shiftKey && e.keyCode === 73) || // Ctrl+Shift+I
        (e.ctrlKey && e.shiftKey && e.keyCode === 74) || // Ctrl+Shift+J
        (e.ctrlKey && e.shiftKey && e.keyCode === 67) || // Ctrl+Shift+C
        (e.ctrlKey && e.keyCode === 85) || // Ctrl+U
        (e.ctrlKey && e.keyCode === 83) || // Ctrl+S
        (e.ctrlKey && e.keyCode === 67) || // Ctrl+C
        (e.ctrlKey && e.keyCode === 88) || // Ctrl+X
        (e.ctrlKey && e.keyCode === 65) // Ctrl+A
      ) {
        e.preventDefault();
        return false;
      }
    };

    // Detect DevTools
    let devtools = { open: false, orientation: null };
    const threshold = 160;

    const detectDevTools = () => {
      const widthThreshold = window.outerWidth - window.innerWidth > threshold;
      const heightThreshold = window.outerHeight - window.innerHeight > threshold;
      const orientation = widthThreshold ? 'vertical' : 'horizontal';

      if (
        !(heightThreshold && widthThreshold) &&
        ((window.Firebug && window.Firebug.chrome && window.Firebug.chrome.isInitialized) || widthThreshold || heightThreshold)
      ) {
        if (!devtools.open || devtools.orientation !== orientation) {
          devtools = { open: true, orientation };
          // Redirect or show warning
          document.body.innerHTML = '<div style="display:flex;justify-content:center;align-items:center;height:100vh;background:#1e3a8a;color:white;font-family:sans-serif;flex-direction:column;"><h1>⚠️ Beveiligingswaarschuwing</h1><p>Developer tools zijn niet toegestaan op deze website.</p><p>Sluit de developer tools om verder te gaan.</p></div>';
        }
      } else {
        devtools.open = false;
      }
    };

    // Detect console usage
    const consoleGuard = () => {
      const element = new Image();
      Object.defineProperty(element, 'id', {
        get: function() {
          document.body.innerHTML = '<div style="display:flex;justify-content:center;align-items:center;height:100vh;background:#1e3a8a;color:white;font-family:sans-serif;flex-direction:column;"><h1>⚠️ Beveiligingswaarschuwing</h1><p>Console toegang is niet toegestaan op deze website.</p></div>';
          throw new Error('Console access blocked');
        }
      });
      console.log('%c', element);
    };

    // Disable drag
    const handleDragStart = (e) => {
      e.preventDefault();
      return false;
    };

    // Add event listeners
    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('selectstart', handleSelectStart);
    document.addEventListener('copy', handleCopy);
    document.addEventListener('cut', handleCopy);
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('dragstart', handleDragStart);

    // Check for DevTools every 1 second
    const devToolsInterval = setInterval(detectDevTools, 1000);

    // Run console guard
    try {
      consoleGuard();
    } catch (e) {
      // Silently catch
    }

    // Disable common debugger tricks
    setInterval(() => {
      // debugger;
    }, 100);

    // Cleanup
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('selectstart', handleSelectStart);
      document.removeEventListener('copy', handleCopy);
      document.removeEventListener('cut', handleCopy);
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('dragstart', handleDragStart);
      clearInterval(devToolsInterval);
    };
  }, []);

  return null;
};

export default CodeProtection;
